import { Box, Dialog, DialogContent, IconButton } from "@mui/material";
import React, { useEffect, useState } from "react";
import CloseIcon from '@mui/icons-material/Close';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowDown, faPrint } from "@fortawesome/free-solid-svg-icons";
import { fetchQuery } from "../../functions/misc";
import { GetTranscriptsByTaxRiskReportId } from "../../queries/GetTranscriptsByTaxRiskReportId";

export interface ItemModalProps {
    onClose: () => void;
    open: boolean;
    alertData: any;
  }
  
  export function TaxReturnTranscriptModal({ onClose, open = false, alertData }: ItemModalProps): React.JSX.Element {

    const [loading, setLoading] = useState(false);
    const [transcriptUrl, setTranscriptUrl] = useState<any>();

    useEffect(() => {
      getTranscript();
    },[]);

    const getTranscript = async () => {
      setLoading(true);
      const taxReturnsTranscripts = await fetchQuery({ taxRiskReportId: alertData.ObjectId, years: [alertData.TaxYear] }, GetTranscriptsByTaxRiskReportId);
      if(taxReturnsTranscripts && taxReturnsTranscripts.length > 0){
        setTranscriptUrl(taxReturnsTranscripts[0]);
      }
    }

    return (
        <>
        <Dialog open={open} sx={{justifyContent: 'center'}} maxWidth={'lg'} fullWidth={true}>
          <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={(theme) => ({
                      position: 'absolute',
                      right: 8,
                      top: 8,
                      bottom: 8,
                      color: theme.palette.grey[500],
                    })}
                  >
                    <CloseIcon />
                  </IconButton>
            <DialogContent sx={{mt: 2}}>
                <Box
                  >
                    <div
                      className="mt-2 mb-2"
                      style={{
                        height: "75vh",
                        overflow: "auto",
                        borderRadius: "5px",
                      }}
                    >
                      <iframe
                        src={transcriptUrl?.PresignedUrl}
                        title="app-logo"
                        name = "transcriptFrame"
                        style={{
                          width: "100%",
                          height: "96%",
                          objectFit: "cover",
                          border: "1px solid #ddd",
                        }}
                      />
                      </div>
                      </Box>
            </DialogContent>
        </Dialog>
        </>
      )
    
  }